<template>
  <body>
    <section role="main">
      <h3>I have read and agree to CI Direct Investing’s<br><a href="#" @click="openModal">PPI Advisor Agreement.</a></h3>
      <button type="button" @click="confirmAgreement">Agree</button>
      <p>
        To use PPI Valet, you must agree to the PPI Advisor Agreement. If you have any questions,
        <a href="mailto:info@cidirectinvesting.com">contact us</a>
      </p>
    </section>
    <modal :fullscreen="true" :displayed="modalDisplayed" title="Agreement" @close="closeModal">
      <section slot="body">
        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing
          elit. Aenean commodo ligula eget dolor. Aenean massa
          <strong>strong</strong>. Cum sociis natoque penatibus
          et magnis dis parturient montes, nascetur ridiculus
          mus. Donec quam felis, ultricies nec, pellentesque
          eu, pretium quis, sem. Nulla consequat massa quis
          enim. Donec pede justo, fringilla vel, aliquet nec,
          vulputate eget, arcu. In enim justo, rhoncus ut,
          imperdiet a, venenatis vitae, justo. Nullam dictum
          felis eu pede <a class="external ext" href="#">link</a>
          mollis pretium. Integer tincidunt. Cras dapibus.
          Vivamus elementum semper nisi. Aenean vulputate
          eleifend tellus. Aenean leo ligula, porttitor eu,
          consequat vitae, eleifend ac, enim. Aliquam lorem ante,
          dapibus in, viverra quis, feugiat a, tellus. Phasellus
          viverra nulla ut metus varius laoreet. Quisque rutrum.
          Aenean imperdiet. Etiam ultricies nisi vel augue.
          Curabitur ullamcorper ultricies nisi.
        </p>

        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing
          elit. Aenean commodo ligula eget dolor. Aenean massa.
          Cum sociis natoque penatibus et magnis dis parturient
          montes, nascetur ridiculus mus. Donec quam felis,
          ultricies nec, pellentesque eu, pretium quis, sem.
        </p>


        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing
          elit. Aenean commodo ligula eget dolor. Aenean massa.
          Cum sociis natoque penatibus et magnis dis parturient
          montes, nascetur ridiculus mus. Donec quam felis,
          ultricies nec, pellentesque eu, pretium quis, sem.
        </p>

        <p>
          Lorem ipsum dolor sit amet, consectetuer adipiscing
          elit. Aenean commodo ligula eget dolor. Aenean massa.
          Cum sociis natoque penatibus et magnis dis parturient
          montes, nascetur ridiculus mus. Donec quam felis,
          ultricies nec, pellentesque eu, pretium quis, sem.
        </p>
      </section>
    </modal>
  </body>
</template>

<script>
import { modal } from '@/components/layout';

export default {
  head() {
    return {
      title: this.$t('PPI Valet - Agreement'),
    };
  },
  components: { modal },
  data() {
    return {
      modalDisplayed: false,
    };
  },
  methods: {
    openModal() {
      this.modalDisplayed = true;
    },
    closeModal() {
      this.modalDisplayed = false;
    },
    confirmAgreement() {
      this.$router.push('/app/clients');
    },
  },
};

</script>
<style scoped lang="scss">


body {
  padding: 0 1rem;

  @media #{$screen-width-small} {
    width: 32rem;
    margin: 3rem auto;
  }
}
section[role="main"] { text-align: center; }
h3 a { color: $black; }
button { margin: 4rem 0; }
</style>
